import { Flex, Text } from '@zorro/web/design-system';
import { useMonolithMutation } from '@zorro/web/ui-utils';

import { ModalFooter } from '../ModalComponents';

type Props = {
  onClose: () => void;
  id: string;
};

export const DeleteCommentForm = ({ onClose, id }: Props) => {
  const { tryMutate: deleteComment } = useMonolithMutation({
    method: 'onboardingPeriodsControllerDeleteEnrollmentComment',
  });
  return (
    <>
      <Text>
        Are you sure you want to delete this message? This cannot be undone
      </Text>
      <Flex justify="flex-end" align="center" mt="md">
        <ModalFooter
          submitText="Delete"
          submitVariant="negative"
          onClose={onClose}
          onSubmit={() => deleteComment([id])}
        />
      </Flex>
    </>
  );
};
